import cn from "classnames";
import { useParams } from "react-router-dom";
import { useGetDiagnosisCodesDisplay } from "../../../../hooks/helpers";
import { RECORD_OF_DISCLOSURE_NOTE_LABELS } from "../../../../utils/constants";
import { IAddendumDetails } from "../../../../modules/notes/types/notes.types";
import NoteContentItem from "../NoteContentItem/NoteContentItem";
import styles from "../../../../modules/notes/components/NoteContent/NoteContent.module.scss";
import useGetDiagnosisCodeToDisplay from "../../../../modules/notes/hooks";
import { formatDate } from "../../../../utils/helpers";
import { useFetchSessionNote } from "../../../../hooks/queries/note";
import CheckIcon from "../../../../icons/Check";

interface ViewRecordOfDisclosureNoteProps {
    noteContent: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any;
    };
    fieldAddendums: {
        [key: string]: IAddendumDetails[];
    } | null;
}

export default function ViewRecordOfDisclosureNote({
    noteContent,
    fieldAddendums,
}: ViewRecordOfDisclosureNoteProps) {
    const params = useParams();

    const noteId = params.noteId as string;
    const clientId = params.clientId as string;

    const { data } = useFetchSessionNote(
        clientId,
        noteId,
        Boolean(clientId) && Boolean(noteId)
    );
    const diagonosisCodes = useGetDiagnosisCodesDisplay(
        noteContent.diagnosis_codes
    );

    const recordOfDisclosureOfPhiEphiDate =
        noteContent.record_of_disclosure_of_phi_ephi
            ? formatDate(noteContent.record_of_disclosure_of_phi_ephi, true)
            : "--";

    return (
        <>
            <NoteContentItem
                headerText={RECORD_OF_DISCLOSURE_NOTE_LABELS.diagnosis_codes}
                fieldId="diagnosis_codes"
                addendums={fieldAddendums?.diagnosis_codes}
                content={
                    diagonosisCodes && Array.isArray(diagonosisCodes) ? (
                        <div className={styles.checkboxes}>
                            {diagonosisCodes.map((code) => (
                                <div className={styles.checkbox} key={code}>
                                    <span
                                        className={cn(styles.checkbox_wrap, {
                                            [styles.checked]: true,
                                        })}
                                    >
                                        <CheckIcon className="stroke-text" />
                                    </span>
                                    {code}
                                </div>
                            ))}
                        </div>
                    ) : (
                        "--"
                    )
                }
            />
            <NoteContentItem
                headerText={
                    RECORD_OF_DISCLOSURE_NOTE_LABELS.secondary_diagnosis
                }
                fieldId="secondary_diagnosis"
                addendums={fieldAddendums?.secondary_diagnosis}
                content={useGetDiagnosisCodeToDisplay(
                    noteContent.secondary_diagnosis
                )}
            />
            <NoteContentItem
                headerText={RECORD_OF_DISCLOSURE_NOTE_LABELS.tertiary_diagnosis}
                fieldId="tertiary_diagnosis"
                addendums={fieldAddendums?.tertiary_diagnosis}
                content={useGetDiagnosisCodeToDisplay(
                    noteContent.tertiary_diagnosis
                )}
            />
            <NoteContentItem
                headerText={
                    RECORD_OF_DISCLOSURE_NOTE_LABELS.additional_diagnosis_one
                }
                fieldId="additional_diagnosis_one"
                addendums={fieldAddendums?.additional_diagnosis_one}
                content={useGetDiagnosisCodeToDisplay(
                    noteContent.additional_diagnosis_one
                )}
            />
            <NoteContentItem
                headerText={
                    RECORD_OF_DISCLOSURE_NOTE_LABELS.additional_diagnosis_two
                }
                fieldId="additional_diagnosis_two"
                addendums={fieldAddendums?.additional_diagnosis_two}
                content={useGetDiagnosisCodeToDisplay(
                    noteContent.additional_diagnosis_two
                )}
            />
            <NoteContentItem
                headerText={RECORD_OF_DISCLOSURE_NOTE_LABELS.disclosure_to_whom}
                fieldId="disclosure_to_whom"
                addendums={fieldAddendums?.disclosure_to_whom}
                content={noteContent.disclosure_to_whom || "--"}
            />
            <NoteContentItem
                headerText={RECORD_OF_DISCLOSURE_NOTE_LABELS.disclosure_type}
                fieldId="disclosure_type"
                addendums={fieldAddendums?.disclosure_type}
                content={noteContent.disclosure_type || "--"}
            />
            <NoteContentItem
                headerText={
                    RECORD_OF_DISCLOSURE_NOTE_LABELS.purpose_of_disclosure
                }
                fieldId="purpose_of_disclosure"
                addendums={fieldAddendums?.purpose_of_disclosure}
                content={noteContent.purpose_of_disclosure || "--"}
            />
            <NoteContentItem
                headerText={RECORD_OF_DISCLOSURE_NOTE_LABELS.type_disclosed}
                fieldId="type_disclosed"
                addendums={fieldAddendums?.type_disclosed}
                content={noteContent.type_disclosed || "--"}
            />
            <NoteContentItem
                headerText={
                    RECORD_OF_DISCLOSURE_NOTE_LABELS.method_of_disclosure
                }
                fieldId="method_of_disclosure"
                addendums={fieldAddendums?.method_of_disclosure}
                content={noteContent.method_of_disclosure || "--"}
            />
            <NoteContentItem
                headerText={
                    RECORD_OF_DISCLOSURE_NOTE_LABELS.record_of_disclosure_of_phi_ephi
                }
                fieldId="record_of_disclosure_of_phi_ephi"
                addendums={fieldAddendums?.record_of_disclosure_of_phi_ephi}
                content={recordOfDisclosureOfPhiEphiDate}
            />
            {data?.data?.date_of_service ? (
                <NoteContentItem
                    headerText={
                        RECORD_OF_DISCLOSURE_NOTE_LABELS.consent_to_charge
                    }
                    fieldId="consent_to_charge"
                    addendums={fieldAddendums?.consent_to_charge}
                    content={
                        <div className={styles.items}>
                            <div className={styles.checkbox}>
                                <span
                                    className={cn(styles.checkbox_wrap, {
                                        [styles.checked]:
                                            noteContent.consent_to_charge,
                                    })}
                                >
                                    <CheckIcon />
                                </span>
                                {
                                    RECORD_OF_DISCLOSURE_NOTE_LABELS.consent_to_charge
                                }
                            </div>
                        </div>
                    }
                />
            ) : null}
        </>
    );
}
